import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PopularService } from '../services/popular.service';

@Component({
  selector: 'app-popular',
  templateUrl: './popular.component.html',
  styleUrls: ['./popular.component.css']
})
export class PopularComponent implements OnInit {
  galleryItems: any[] = [];
  constructor(private http: HttpClient, private popularService: PopularService) {}

  ngOnInit(): void {
    this.fetchGalleryItems();
  }

  fetchGalleryItems(){
    this.popularService.getData().subscribe((response) => {
      this.galleryItems = response.data;
    });


    
  }

}
